import React, { useEffect, useMemo, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { buyers } from '../data/buyers';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 6000;
const GAP_MS = 12000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const timers = useRef<number[]>([]);
  const minutesAgo = useMemo(() => buyers.map((_, i) => i * 7 % 23 + 2), []);
  useEffect(() => {
    if (dismissed) return;
    const show = () => {
      setVisible(true);
      timers.current.push(window.setTimeout(() => {
        setVisible(false);
        timers.current.push(window.setTimeout(() => {
          setIndex(prev => (prev + 1) % buyers.length);
          show();
        }, GAP_MS));
      }, VISIBLE_MS));
    };
    timers.current.push(window.setTimeout(show, FIRST_DELAY));
    return () => {
      timers.current.forEach(id => window.clearTimeout(id));
      timers.current = [];
    };
  }, [dismissed]);
  const buyer = buyers[index];
  return <AnimatePresence data-id="element-20" data-mp="1fuh9wavriwj4">
      {visible && !dismissed && <motion.div initial={{
      opacity: 0,
      x: -16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      x: -16,
      scale: 0.98
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[320px] sm:bottom-28 sm:left-5" role="status" aria-live="polite" data-id="element-21" data-mp="1awzapc7jrvob">
          <div className="flex items-start gap-3 rounded-2xl border border-navy-900/10 bg-white p-3.5 shadow-[0_14px_36px_-12px_rgba(7,24,42,0.35)]" data-id="element-22" data-mp="s5ydasm2s86v">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-100" data-id="element-23" data-mp="28mkghr0s3r6j">
              <CheckCircle2Icon className="h-5 w-5 text-brand-600" aria-hidden="true" data-id="element-24" data-mp="2aol6kj26wm5w" />
            </span>
            <div className="min-w-0 flex-1" data-id="element-25" data-mp="2fnnzj54wb1xi">
              <p className="text-[13px] font-bold leading-snug text-navy-900" data-id="element-26" data-mp="2fmcvr5bg9u6e">
                {buyer.name} <span className="font-medium text-navy-800/70" data-id="element-27" data-mp="2knsg0v5szwnq">from {buyer.country}</span>
              </p>
              <p className="mt-0.5 text-[12px] font-medium leading-snug text-navy-800/80" data-id="element-28" data-mp="2pkj0duon5eey">
                just purchased ALIGNER CASE COMMANDER™
              </p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-brand-600" data-id="element-29" data-mp="1wwn3opz2nmi6">
                {minutesAgo[index]} minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 rounded-full p-1.5 text-navy-800/40 transition-colors duration-150 ease-out hover:bg-mist hover:text-navy-900" data-id="element-30" data-mp="26mzn2ev5h9mq">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-31" data-mp="3rgomlny4pt68" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}